import { WorkflowRoutingAgent } from '~/features/ask-anything/agentic-ai/workflow-routing/WorkflowRoutingAgent';

import { AGENT_IDS } from './agentIds';
import { agentRegistry } from './AgentRegistry';

/**
 * Register all available agents with the registry
 * This should be called once during app initialization
 */
export const registerAgents = (hasWorkflowRoutingAgent: boolean): void => {
  if (hasWorkflowRoutingAgent) {
    agentRegistry.register({
      id: AGENT_IDS.WORKFLOW_ROUTING,
      component: WorkflowRoutingAgent,
      label: 'Workflow Routing',
      description: 'Ask AI to route to a workflow',
      icon: 'workflow-routing-agent',
    });
  }
};
